import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        py: 2,
        px: 3,
        borderTop: '1px solid #e0e0e0',
        bgcolor: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 1000,
        boxShadow: '0 -2px 4px rgba(0,0,0,0.05)'
      }}
    >
      <Typography variant="body2" color="text.secondary">
        TICSPL – With You All The Way
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Powered by <strong>Absolin Digital</strong>
      </Typography>
    </Box>
  );
};

export default Footer;
